export const ASSIGNING_CONTACT_TEXT = 'Assigning your HFS Contact';
